import React, { useEffect } from "react";
import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Col,
  Form,
  FormFeedback,
  Input,
  Label,
  Row,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { withTranslation } from "react-i18next";
import withRouter from "../../../../components/Common/withRouter";
import { createSelector } from "reselect";
import {
  getGroupedPayrollSettings,
  getStaffDetails,
  updateEmployee as onUpdateEmployee,
} from "../../../../slice/thunks";
import { toast } from "react-toastify";

const UpdateEmployee = (props) => {
  const dispatch = useDispatch();
  const history = useNavigate();
  const { id } = useParams(); // récupère l'ID de l'URL

  const selectLayoutState = (state) => state.Settings;
  const SettingsProperties = createSelector(selectLayoutState, (setting) => ({
    groupedPayrollSettings: setting.groupedPayrollSettings,
    employeeDetails: setting.staffDetails,
    error: setting.error,
  }));

  const { groupedPayrollSettings, employeeDetails } =
    useSelector(SettingsProperties);

  // Charger les settings & détails de l'employé
  useEffect(() => {
    dispatch(getGroupedPayrollSettings());
    dispatch(getStaffDetails(id));
  }, [dispatch, id]);

 const getIdFromLabel = (settingKey, label) => {
  if (!groupedPayrollSettings?.[settingKey]) return "";
  const found = groupedPayrollSettings[settingKey].find(
    (item) => item.label === label
  );
  return found ? found.id : "";
};

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      fullName: employeeDetails?.fullName || "",
      matricule: employeeDetails?.matricule || "",
      cnpsNumber: employeeDetails?.cnpsNumber || "",
      gender: employeeDetails?.gender || "",
      dob: employeeDetails?.dob || "",
      email: employeeDetails?.email || "",
      phone: employeeDetails?.phone || "",
      maritalStatus: employeeDetails?.maritalStatus || "",
      salary: employeeDetails?.salary || 0,
      taxable: employeeDetails?.taxable === true ? "yes" : "no",
      staffTypeId: getIdFromLabel("StaffType", employeeDetails?.staffType) || "",
      positionId: getIdFromLabel("Position", employeeDetails?.positions) || "",
      departmentId: getIdFromLabel("Department", employeeDetails?.department) || "",
      echelonId: getIdFromLabel("Echelon", employeeDetails?.echelon) || "",
      categoryId: getIdFromLabel("Category", employeeDetails?.category) || "",
      employmentDate: employeeDetails?.employmentDate || "",
    },
    validationSchema: Yup.object({
      fullName: Yup.string().required("Full name is required"),
      gender: Yup.string().required("Gender is required"),
      dob: Yup.date().required("Date of birth is required"),
      email: Yup.string().email("Invalid email"),
      maritalStatus: Yup.string().required("Marital status is required"),
      salary: Yup.number().min(0, "Invalid salary"),
      taxable: Yup.string().required("Taxable status is required"),
      staffTypeId: Yup.string().required("Staff type is required"),
      positionId: Yup.string().required("Position is required"),
      departmentId: Yup.string().required("Department is required"),
      echelonId: Yup.string().required("Echelon is required"),
      categoryId: Yup.string().required("Category is required"),
      employmentDate: Yup.date().required("Employment date is required"),
    }),
    onSubmit: (values) => {
      dispatch(onUpdateEmployee({ id, ...values }))
        .unwrap()
        .then((res) => {
          toast.success(res.message || "Employee updated successfully");
          history("/payroll/staff-management");
        })
        .catch((err) => {
          const errorMessage =
            err?.response?.data?.message || err?.message || "An error occurred";
          toast.error(errorMessage);
        });
    },
  });

  const renderSelect = (label, name, options) => (
    <div className="mb-3">
      <Label className="form-label">{label} <em className="text-danger">*</em></Label>
      <Input
        type="select"
        name={name}
        value={validation.values[name]}
        onChange={validation.handleChange}
        onBlur={validation.handleBlur}
        invalid={validation.touched[name] && !!validation.errors[name]}
      >
        <option value="">Select {label}</option>
        {options.map((item) => (
          <option key={item.id} value={item.id}>
            {item.label}
          </option>
        ))}
      </Input>
      <FormFeedback>{validation.errors[name]}</FormFeedback>
    </div>
  );

  return (
    <div className="all-payrollSettings-setting px-3">
      <div className="patients-list py-4 px-2">
        <div className="container-fluid">
          <div className="row list-patients d-flex justify-content-between">
            <div className="col-lg-5">
              <h6>{props.t("update_employee")}</h6>
            </div>
          </div>

          <Card className="container p-0">
            <CardHeader className="bg-light p-3">
              {props.t("update_employee")}
            </CardHeader>

            <Form
              className="tablelist-form"
              autoComplete="off"
              onSubmit={(e) => {
                e.preventDefault();
                validation.handleSubmit();
                return false;
              }}
            >
                            <CardBody>
                              <div className="container">
                                <Row>
                                  <Col xl={6} sm={12}>
                                    <div className="mb-3">
                                      <Label className="form-label">Full Name <em className="text-danger">*</em></Label>
                                      <Input
                                        name="fullName"
                                        type="text"
                                        value={validation.values.fullName}
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        invalid={
                                          validation.touched.fullName &&
                                          !!validation.errors.fullName
                                        }
                                      />
                                      <FormFeedback>
                                        {validation.errors.fullName}
                                      </FormFeedback>
                                    </div>
                                  </Col>

                                  <Col xl={6} sm={12}>
                                    <div className="mb-3">
                                      <Label className="form-label">Matricule</Label>
                                      <Input
                                        name="matricule"
                                        type="text"
                                        value={validation.values.matricule}
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        invalid={
                                          validation.touched.matricule &&
                                          !!validation.errors.matricule
                                        }
                                      />
                                      <FormFeedback>
                                        {validation.errors.matricule}
                                      </FormFeedback>
                                    </div>
                                  </Col>
                                </Row>

                                <Row>
                                  <Col xl={6} sm={12}>
                                    <div className="mb-3">
                                      <Label className="form-label">CNPS Number</Label>
                                      <Input
                                        name="cnpsNumber"
                                        type="text"
                                        value={validation.values.cnpsNumber}
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        invalid={
                                          validation.touched.cnpsNumber &&
                                          !!validation.errors.cnpsNumber
                                        }
                                      />
                                      <FormFeedback>
                                        {validation.errors.cnpsNumber}
                                      </FormFeedback>
                                    </div>
                                  </Col>

                                  <Col xl={6} sm={12}>
                                    <div className="mb-3">
                                      <Label className="form-label">Date of Birth <em className="text-danger">*</em></Label>
                                      <Input
                                        name="dob"
                                        type="date"
                                        value={validation.values.dob}
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        invalid={
                                          validation.touched.dob && !!validation.errors.dob
                                        }
                                      />
                                      <FormFeedback>{validation.errors.dob}</FormFeedback>
                                    </div>
                                  </Col>
                                </Row>

                                <Row>
                                  <Col xl={6} sm={12}>
                                    {renderSelect("Gender", "gender", [
                                      { id: "M", label: "Male" },
                                      { id: "F", label: "Female" },
                                    ])}
                                  </Col>

                                  <Col xl={6} sm={12}>
                                    {renderSelect("Marital Status", "maritalStatus", [
                                      { id: "SINGLE", label: "Single" },
                                      { id: "MARRIED", label: "Married" },
                                    ])}
                                  </Col>
                                </Row>

                                <Row>
                                  <Col xl={6} sm={12}>
                                    <div className="mb-3">
                                      <Label className="form-label">Email</Label>
                                      <Input
                                        name="email"
                                        type="email"
                                        value={validation.values.email}
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        invalid={
                                          validation.touched.email &&
                                          !!validation.errors.email
                                        }
                                      />
                                      <FormFeedback>{validation.errors.email}</FormFeedback>
                                    </div>
                                  </Col>

                                  <Col xl={6} sm={12}>
                                    <div className="mb-3">
                                      <Label className="form-label">Phone</Label>
                                      <Input
                                        name="phone"
                                        type="text"
                                        value={validation.values.phone}
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        invalid={
                                          validation.touched.phone &&
                                          !!validation.errors.phone
                                        }
                                      />
                                      <FormFeedback>{validation.errors.phone}</FormFeedback>
                                    </div>
                                  </Col>
                                </Row>

                                <Row>
                                  <Col xl={6} sm={12}>
                                    {renderSelect("Taxable", "taxable", [
                                      { id: "yes", label: "Taxable" },
                                      { id: "no", label: "Not taxable" },
                                    ])}
                                  </Col>

                                  <Col xl={6} sm={12}>
                                    <div className="mb-3">
                                      <Label className="form-label">Salary</Label>
                                      <Input
                                        name="salary"
                                        type="number"
                                        value={validation.values.salary}
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        invalid={
                                          validation.touched.salary &&
                                          !!validation.errors.salary
                                        }
                                      />
                                      <FormFeedback>{validation.errors.salary}</FormFeedback>
                                    </div>
                                  </Col>
                                </Row>
                                  <Row>
                                                    
                                                  </Row>

                                <Row>
                                  <Col xl={6} sm={12}>
                                                      <div className="mb-3">
                                                        <Label className="form-label">Employment Date</Label>
                                                        <Input
                                                          name="employmentDate"
                                                          type="date"
                                                          value={validation.values.employmentDate}
                                                          onChange={validation.handleChange}
                                                          onBlur={validation.handleBlur}
                                                          invalid={
                                                            validation.touched.employmentDate &&
                                                            !!validation.errors.employmentDate
                                                          }
                                                        />
                                                        <FormFeedback>
                                                          {validation.errors.employmentDate}
                                                        </FormFeedback>
                                                      </div>
                                                    </Col>
                                  <Col xl={6} sm={12}>
                                    {renderSelect(
                                      "Staff Type",
                                      "staffTypeId",
                                      groupedPayrollSettings?.StaffType || []
                                    )}
                                  </Col>
                             
                                </Row>

                                <Row>
                                       <Col xl={6} sm={12}>
                                    {renderSelect(
                                      "Department",
                                      "departmentId",
                                      groupedPayrollSettings?.Department || []
                                    )}
                                  </Col>
                                  <Col xl={6} sm={12}>
                                    {renderSelect(
                                      "Position",
                                      "positionId",
                                      groupedPayrollSettings?.Position || []
                                    )}
                                  </Col>
                          
                                </Row>

                                <Row>
                                          <Col xl={6} sm={12}>
                                    {renderSelect(
                                      "Echelon",
                                      "echelonId",
                                      groupedPayrollSettings?.Echelon || []
                                    )}
                                  </Col>
                                  <Col xl={6} sm={12}>
                                    {renderSelect(
                                      "Category",
                                      "categoryId",
                                      groupedPayrollSettings?.Category || []
                                    )}
                                  </Col>
                                </Row>
                              </div>
              </CardBody>

              <CardFooter>
                <div className="p-3">
                  <Row className="align-items-center">
                    <div className="col-sm">
                      <span className="text-danger align-middle">
                        * : Required fields
                      </span>
                    </div>
                    <div className="col-sm-auto">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-secondary"
                          onClick={() =>
                            history("/payroll/staff-management")
                          }
                        >
                          {props.t("close")}
                        </button>
                        <button type="submit" className="btn btn-success">
                          {props.t("save_changes")}
                        </button>
                      </div>
                    </div>
                  </Row>
                </div>
              </CardFooter>
            </Form>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default withRouter(withTranslation()(UpdateEmployee));
